import axios from 'axios';

function encode(data) {
  return Object.keys(data)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join('&');
}

function contactUs(data) {
  const axiosConfig = {
    header: { 'Content-Type': 'application/x-www-form-urlencoded' },
  };

  return axios.post(
    '/',
    encode({
      'form-name': 'contact-request',
      ...data,
    }),
    axiosConfig,
  );
}

export default {
  contactUs,
};